import ajax from './index'
import apiEnv from './apiEnv'



//新闻管理列表
export function newListApi(data) {
    return ajax.post(`${apiEnv.api2}/news/news/list`,data)
}
//新闻类型
export function newsType(data) {
    return ajax.post(`${apiEnv.api2}/news/newsType/list/select`,data)
}
//新闻新增
export function addNews(data) {
    return ajax.post(`${apiEnv.api2}/news/news/add`,data)
}
//新闻详情
export function getNewsById(data) {
    return ajax.post(`${apiEnv.api2}/news/news/getById`,data)
}
//新闻编辑
export function editNews(data) {
    return ajax.post(`${apiEnv.api2}/news/news/update`,data)
}